import React from "react";
import { Building2 } from "lucide-react";
import { useBusiness } from "../context/BusinessContext";

const OPTIONS = [
  { value: "", label: "All businesses" },
  { value: "A van Greunen", label: "A van Greunen" },
  { value: "NetMark Pro", label: "NetMark Pro" },
];

export default function BusinessFilter() {
  const { business, setBusiness } = useBusiness();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="business-filter">
      <span className="np-label inline-flex items-center gap-1">
        <Building2 className="w-3.5 h-3.5" /> Business
      </span>
      {OPTIONS.map((o) => (
        <button
          key={o.value || "all"}
          data-testid={`biz-filter-${o.value ? o.value.replace(/\s/g, "-") : "all"}`}
          onClick={() => setBusiness(o.value)}
          className={`px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider transition ${
            business === o.value
              ? "bg-[#00ACB3] text-white"
              : "bg-white text-[#595959] border border-[#CCCCCC] hover:border-[#0F4F51]"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
